/* @sravni/react-design-system version 0.2.65 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { COLORS } from '../../../constants/colors.js';
import modules_441c7b04 from '../styles/Badge.module.less.js';
import { VARIANTS } from '../../../constants/variants.js';

/**
 * @description The Badge component is label with a background color
 *
 * @component
 * @example
 * ```jsx
 * <Badge color="green">Личные финансы</Badge>
 * ```
 */
var Badge = React.forwardRef(function (props, ref) {
    var _a;
    var text = props.text, variant = props.variant, color = props.color, shape = props.shape, placement = props.placement, className = props.className, children = props.children, restProps = __rest(props, ["text", "variant", "color", "shape", "placement", "className", "children"]);
    var cx = useStyles(modules_441c7b04);
    var hasChildren = children !== undefined;
    var classNames = cx(className, 'container');
    var elementClassNames = cx('element', (_a = {},
        _a["color-" + color + "-" + variant] = true,
        _a["shape-" + shape] = shape && text,
        _a['shape-dot'] = !text,
        _a.floating = hasChildren,
        _a["floating-" + placement] = hasChildren,
        _a));
    return (React.createElement("span", __assign({ ref: ref, "data-qa": "Badge", className: classNames }, restProps),
        children,
        React.createElement("span", { className: elementClassNames }, text)));
});
Badge.defaultProps = {
    variant: VARIANTS.SECONDARY,
    color: COLORS.GRAY,
    shape: 'round',
    placement: 'top-end',
};
Badge.displayName = 'Badge';

export default Badge;
//# sourceMappingURL=Badge.js.map
